import React, { createContext, useState, useContext } from 'react';

const STORAGE_KEY = 'whizr_current_location';
const CurrentLocationContext = createContext();

function readFromStorage() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export default function CurrentLocationProvider({ children }) {
    const [currentLocation, _setCurrentLocation] = useState(readFromStorage);

    function setCurrentLocation(value) {
        _setCurrentLocation(value);
        try {
            if (value) localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
            else localStorage.removeItem(STORAGE_KEY);
        } catch { /* storage unavailable */ }
    }

    return (
        <CurrentLocationContext.Provider value={{ currentLocation, setCurrentLocation }}>
            {children}
        </CurrentLocationContext.Provider>
    );
}

export function useCurrentLocation() {
    const context = useContext(CurrentLocationContext);
    if (!context) throw new Error('useCurrentLocation must be used within a CurrentLocationProvider');
    return context;
}
